import { useMemo, useState } from 'react';
import { useDataEnvironment } from 'contexts/DataEnvironmentContext';
import { NavbarBrand } from 'react-bootstrap';
import Logo from '../../assets/images/Nasdaq-N-Navbar.svg';
import {
  HeaderContainer,
  HeaderName,
  SelectWrapper,
  HeaderTitle,
  Img,
} from './HeaderStyles';
import { useDataEnvironments } from 'api/queries/useDataEnvironments';
import { useHistory } from 'react-router-dom';
import { Question } from 'components/Icons';
import HeaderDropdown from 'components/HeaderDropdown/HeaderDropdown';

import EnvOptions from './EnvOptions/EnvOptions';
import ProjectOptions from './ProjectOptions/ProjectOptions';
import { questionOptions, profileOptions, AppModulesSort } from './config';
import { DataEnvironment, SOLOVIS_ACADAMY_MODULE } from 'types/DataEnvironment';
import { paths } from 'routes';

type Props = {
  fullName: string;
};

export default function Header({ fullName }: Props) {
  const [dataEnvironment, setDataEnvironment] = useDataEnvironment();
  const [appModule, setAppModule] = useState<string>();
  const { showUserInfo, showEnvironmentsInfo } = useMemo(() => {
    const hasAccess = window.location.pathname !== paths.noAccess;
    // in case additional rules applied
    return {
      showUserInfo: hasAccess,
      showEnvironmentsInfo: hasAccess,
    };
  }, [window.location]);

  const { data } = useDataEnvironments();
  const history = useHistory();

  const onChangedEnvironmentId = (dataEnvironment: DataEnvironment) => {
    setDataEnvironment(dataEnvironment);
    history.push('/');
  };

  const solovisAcadamyApp = useMemo(() => {
    return dataEnvironment?.links?.find(
      (link) => link.moduleName === SOLOVIS_ACADAMY_MODULE
    );
  }, [dataEnvironment]);

  const links = useMemo(() => {
    return (
      dataEnvironment?.links?.sort((a, b) => {
        const posA: number = AppModulesSort.get(a.moduleName) ?? 110;
        const posB: number = AppModulesSort.get(b.moduleName) ?? 110;

        return posA - posB;
      }) ?? []
    );
  }, [dataEnvironment]);

  const sortedEnv = useMemo(() => {
    return (
      data?.sort((a, b) => {
        const nameA = a.name.toLocaleLowerCase();
        const nameB = b.name.toLocaleLowerCase();

        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        return 0;
      }) || []
    );
  }, [data]);

  return (
    <>
      <HeaderContainer fluid>
        <NavbarBrand>
          <a href={dataEnvironment?.url}>
            <Img src={Logo} alt='Nasdaq' />
          </a>
          <HeaderDropdown
            options={questionOptions}
            selectedItem={appModule}
            customOption={
              <ProjectOptions
                options={links}
                onClick={() => setAppModule(new Date().getTime().toString())}
              />
            }
          >
            <HeaderTitle>Benchmark Blender</HeaderTitle>
          </HeaderDropdown>
        </NavbarBrand>
        {showEnvironmentsInfo && (
          <SelectWrapper>
            <HeaderDropdown
              options={questionOptions}
              customOption={
                <EnvOptions
                  active={dataEnvironment}
                  onChange={onChangedEnvironmentId}
                  options={sortedEnv}
                />
              }
              selectedItem={dataEnvironment}
            >
              <HeaderName>{dataEnvironment?.name}</HeaderName>
            </HeaderDropdown>
          </SelectWrapper>
        )}
        {showUserInfo && (
          <SelectWrapper>
            <HeaderDropdown
              options={profileOptions}
              styles={{
                Options: {
                  width: '100%',
                },
              }}
              onItemClick={(title) => {
                if (title === 'Sign Out') {
                  sessionStorage.removeItem('jwt');
                  window.location.replace(
                    `${dataEnvironment?.url}/Account/Logout`
                  );
                }
              }}
            >
              <HeaderName>{fullName}</HeaderName>
            </HeaderDropdown>
          </SelectWrapper>
        )}
        {solovisAcadamyApp?.url ? (
          <a href={solovisAcadamyApp?.url} target='_blank'>
            <Question fill={'#fff'} size='18px' />
          </a>
        ) : null}
      </HeaderContainer>
    </>
  );
}
